import { driver } from 'driver.js';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const useSegmentsTour = () => {
  const driverRef = useRef<any>(null);
  const { t } = useTranslation();

  const initDriver = () => {
    driverRef.current = driver({
      showProgress: true,
      allowClose: true,
      doneBtnText: t('Finalizar'),
      nextBtnText: t('Siguiente'),
      prevBtnText: t('Anterior'),
      steps: [
        {
          element: '#segments-name',
          popover: {
            title: 'Franjas!',
            description: 'Aqui veremos TODAS las franjas creadas',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#shorcut',
          popover: {
            title: 'Atajos de teclado',
            description: 'Dandole click a este icono puedes ver los atajos de teclado disponibles',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-filter',
          popover: {
            title: 'Filtros de franjas',
            description: 'Aqui tienes todos los filtros disponibles para buscar las franjas',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-fast-filters',
          popover: {
            title: 'Filtros rápidos',
            description:
              'Estos son todos los filtros rápidos que puedes usar para buscar las franjas',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-column-filters',
          popover: {
            title: 'Filtros de columnas',
            description: 'Con estos botones puedes controlar la visibilidad de las columnas',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-list',
          popover: {
            title: 'Listado de franjas',
            description:
              'Aquí estará el listado de franjas que se ajusten a los filtros seleccionados',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-detail',
          popover: {
            title: 'Detalle de la franja',
            description: 'Aqui estará el detalle de la franja seleccionada',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-toolkit',
          popover: {
            title: 'Toolkits disponibles',
            description:
              'En esta columna podras ver las toolkits disponibles para la franja seleccionada',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#help',
          popover: {
            title: 'Ayuda',
            description:
              'Para iniciar el tour de ayuda, haz click en este icono y sigue las instrucciones',
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    });
  };

  const startTour = () => {
    if (!driverRef.current) {
      initDriver();
    }
    driverRef.current.drive();
  };

  return { startTour };
};
